import React, { useState } from "react";
import { XpressCardlockApplicationForm } from "../../components/parts/forms";
import { SectionTitle } from "../../components/styledComponent";
import { Loader } from "../../components/ui";
import successGif from "../../assets/successGif.gif";
import cancoconnect from "../../assets/cancoconnectblue.png";
import cancoxpress from "../../assets/xpressDark.png";
import styles from "./style.module.scss";

const XpressCardlockApplication = () => {
  const [loader, setLoader] = useState(false);
  const [successBox, setSuccessBox] = useState(false);
  return (
    <div className={`${styles.xpressCardlockApplicationPage} sectionContainer`}>
      <div className={styles.xpressCardlockApplicationInner}>
        <div className={styles.headerSection}>
          <img src={cancoconnect} alt="Canco Connect" />
          <SectionTitle>Xpress/Cardlock Application Form</SectionTitle>
          <img src={cancoxpress} alt="Canco Express" />
        </div>
        {!successBox && (
          <XpressCardlockApplicationForm
            loader={(val) => setLoader(val)}
            success={(val) => setSuccessBox(val)}
          />
        )}
        {loader && (
          <div className={styles.loaderBox}>
            <Loader />
          </div>
        )}
        {successBox && (
          <div className={styles.successBox}>
            <img src={successGif} alt="Success" />
            <h3>
              Thank you
              <br />
              Your response is submitted successfully.
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default XpressCardlockApplication;
